import { type Submission } from './submission';
import { type FormRule } from '@wix/ambassador-forms-v4-form/types';
import { defaultEngine, Rule } from 'js-rules-engine';
import { setUpOperators } from './set-up-operators';

export function evaluateOverrideConditionFactory(
  dateFactory: () => Date = () => new Date(),
) {
  setUpOperators(defaultEngine, dateFactory);

  return function evaluateOverrideCondition(
    override: FormRule,
    submission: Submission = {},
  ): boolean {
    if (override.condition) {
      try {
        const rule = getRule(override.condition);
        return rule.evaluate(submission);
      } catch (e) {
        console.error(e);
        return false;
      }
    }
    return true;
  };

  function getRule(condition: object): Rule {
    return new Rule(condition);
  }
}
